import { create } from 'zustand';

interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  agentUsed?: string;
  actions?: Array<{
    type: string;
    data: unknown;
  }>;
}

interface ChatState {
  messages: Message[];
  isLoading: boolean;
  conversationId: string | null;
  
  // Actions
  addMessage: (message: Omit<Message, 'id' | 'timestamp'>) => void;
  setLoading: (loading: boolean) => void;
  setConversationId: (id: string) => void;
  clearMessages: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  isLoading: false,
  conversationId: null,

  addMessage: (message) =>
    set((state) => ({
      messages: [
        ...state.messages,
        {
          ...message,
          id: crypto.randomUUID(),
          timestamp: new Date(),
        },
      ],
    })),

  setLoading: (isLoading) => set({ isLoading }),

  setConversationId: (conversationId) => set({ conversationId }),

  clearMessages: () => set({ messages: [], conversationId: null }),
}));

